import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import LanguageContext from "../../helper/LanguageContext";
import { callAPI } from "../../helper/apiUtils";
import { Scrollbars } from "react-custom-scrollbars";
import _ from "lodash";
import { BASE_URL, KJUUP_COLORS, capitalizeFirstLetter } from "../../helper/constants";
import { $crud } from "../../helper/CrudFactory";
import { BsFillXCircleFill } from "react-icons/bs";
import InviteProjectUser from "./InviteProjectUser";
import { convertBranchRole, convertPosition } from "../../helper/convertor";
import { useSelector } from "react-redux";
import { $user } from "../../helper/UserFactory";
import { Discuss, Rings, Oval } from 'react-loader-spinner'
import ImageWithPlaceholder from "../../components/ImageWithPlaceholder";
import { debounce } from 'lodash';
import "./AddProjectUser.css";


const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    backgroundColor: "rgba(230, 132, 56, 0.8)",
  };
  return (
    <div
      className="thumb-style"
      style={{ ...style, ...thumbStyle }}
      {...props}
    />
  );
};

const CustomScrollbars = (props) => (
  <Scrollbars
    renderThumbHorizontal={renderThumb}
    renderThumbVertical={renderThumb}
    {...props}
  />
);

function AddProjectUser(props) {
  const { isGerm, strings } = React.useContext(LanguageContext);
  const [inviteLink, setInviteLink] = useState(false);
  const [search, setSearch] = useState("");
  const [users, setUsers] = useState([]);
  const [userList, setUsersList] = useState([]);
  const [postUser, setPostUser] = useState(props.allUsers);
  const id = props.project_id;
  const [isAllMember, setIsAllMember] = useState(false)
  const user = useSelector((state) => state.user);
  const [profile, setProfile] = useState({});
  const [openCompanies, setOpenCompanies] = useState(new Set())
  const [comps, setComps] = useState([])
  const [selectedIds, setSelectedIds] = useState([])
  const [searchList, setSearchList] = useState([])
  const [allTogether, setTogether] = useState([])
  const [loader, setLoader] = useState(false)
  const [allToSearch, setAllToSearch] = useState([])
  const [allToSearchBack, setAllToSearchBack] = useState([])
  const [limit] = useState(20);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [currentSearchTerm, setCurrentSearchTerm] = useState("");
  const [project, setProject] = useState(null);
  const [deeplink, setDeepLink] = useState("");

  // Paging: the BE pages by last name and its pages also hold people who are already in the
  // project/group (with a groupId it even adds the group's members back). Those rows are hidden
  // here, so one page can show only a few people — too few to scroll, and the next page (loaded
  // on scroll) never came. Keep fetching until a load adds `limit` people we can actually show.
  const nextPageRef = useRef(1);
  const loadingRef = useRef(false);
  const requestRef = useRef(0);

  const isShownCandidate = (u) =>
    u && u.id != user?.id && !(props.Mems || []).some((m) => m.id == u.id);

  const fetchContactsPage = async (page, searchQuery) => {
    const q = encodeURIComponent(searchQuery || "");
    const companyPart = props.isInternal ? `company_id=${props.cID}&` : "";
    const groupPart = props.groupId ? `groupId=${props.groupId}&` : "";
    const { data } = await callAPI(
      `/building/${id}/getMyBuildingContacts?${companyPart}${groupPart}page=${page}&search=${q}&limit=${limit}`,
      {},
      "GET"
    );
    return data?.status ? (data.users || []) : null;
  };

  const getNonMembers = async (page = 1, searchQuery = '') => {
    // A new first page (open / new search) always wins over a load still running.
    if (page > 1 && loadingRef.current) return;
    const requestId = ++requestRef.current;
    loadingRef.current = true;
    setIsLoading(true);
    try {
      let current = page;
      let collected = [];
      let shown = 0;
      let more = true;
      // At most 10 pages per load, so a large company never fetches everything at once.
      for (let i = 0; i < 10 && more && shown < limit; i++) {
        const arrList = await fetchContactsPage(current, searchQuery);
        if (requestId !== requestRef.current) return;
        if (!arrList) { more = false; break; }
        collected = [...collected, ...arrList];
        shown += arrList.filter(isShownCandidate).length;
        more = arrList.length === limit;
        current += 1;
      }
      nextPageRef.current = current;
      setHasMore(more);

      if (page === 1) {
        setUsers([]);
        setUsersList([]);
        setAllToSearch([]);
        setAllToSearchBack([]);
      }
      await CreateList(collected, page > 1);
    } catch (error) {
      console.error('Search error:', error);
    } finally {
      if (requestId === requestRef.current) {
        loadingRef.current = false;
        setIsLoading(false);
      }
    }
  };

  const loadMore = () => {
    if (!hasMore || loadingRef.current) return;
    getNonMembers(nextPageRef.current, search);
  };

  // Letter of a contact's group; a missing/empty last name must not throw (that dropped the page).
  const initialOf = (u) => {
    const n = String(u?.lastName || u?.firstName || "").trim();
    return n ? n[0].toUpperCase() : "#";
  };

  const CreateList = async (users, append = false) => {
    const arr = _.uniqBy(
      (users || []).map((u) => ({ name: initialOf(u) })),
      "name"
    );
    const updatedArr = _.sortBy(arr, ["name"]);
    const usersList = updatedArr.map((a) => {
      a.names = users.filter((u) => initialOf(u) == a.name);
      return a;
    });
    
    if (append) {
      setUsers(prev => [...prev, ...usersList]);
      setUsersList(prev => [...prev, ...usersList]);
      setAllToSearch(prev => [...prev, ...users]);
      setAllToSearchBack(prev => [...prev, ...users]);
    } else {
    setUsers(usersList);
    setUsersList(usersList);
      setAllToSearch(users);
      setAllToSearchBack(users);
    }
  };

  const getAllCompnies = async () => {
    const { data } = await callAPI('/company/getCompaniesWithUser',
      {},
      "GET"
    );
    let rmpss = []
    if (data.companies) {
      let tmp = data.companies.map(e => {
        e.employees = e.users.filter((value, index, self) => {
          return index === self.findIndex((t) => (
            t.id === value.id
          ))
        })
        e.employees = e.employees.filter((x) => {
          let indArr = props.Mems ? props.Mems : []
          let ind = indArr.findIndex(b => b.id == x.id)
          if (ind == -1) {
            return true
          }
          else {
            return false
          }
        })
        rmpss = [...rmpss, ...e.employees]
        return { ...e }
      })
      setComps([...tmp])
      if (tmp.length > 0) setOpenCompanies(new Set([tmp[0].id]));
      rmpss = rmpss.filter((value, index, self) => {
        return index === self.findIndex((t) => (
          t.id === value.id
        ))
      })
      setTogether([...rmpss])
    }
  };

  useEffect(() => {
    if (!props.isInternal) {
      let tmp = [...users]
      let allToSearch = []
      tmp = tmp.map((e) => {
        e.names = e.names.filter(x => {
          let indd = allTogether.findIndex(z => z.id == x.id)
          if (indd !== -1) {
            return false
          }
          else {
            return true
          }
        })
        allToSearch = [...allToSearch, ...e.names]
        return { ...e }
      })
      allToSearch = [...allToSearch, ...allTogether]
      allToSearch = allToSearch.filter((value, index, self) => {
        return index === self.findIndex((t) => (
          t.id === value.id
        ))
      })
      setUsers([...tmp])
      setUsersList([...tmp])
      setAllToSearch([...allToSearch])
      setAllToSearchBack([...allToSearch])
    }
  }, [allTogether])

  useEffect(() => {
    setSearchList([...comps])
  }, [comps])

  useEffect(() => {
    getAllCompnies()
    getNonMembers(1, search)
  }, [user]);

  const debouncedFilterUsers = debounce((searchValue) => {
    setHasMore(true);
    getNonMembers(1, searchValue);
  }, 300);


  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    debouncedFilterUsers(value);
  };

  const getProjectDetails = async () => {
    const id = props.project_id;
    const { data } = await callAPI(`/building/one/${id}`, {}, "GET");
    if (data) {
      await setProject(data);
    }
  };

  const getInviteLink = async () => {
    const id = props.project_id;
    const { data } = await callAPI(
      `/invite-user/deeplink`,
      {
        inviteType: "buildingList",
        buildingList: id,
      },
      "POST"
    );
    if (data.status) {
      let splitToken = data?.deeplinkUrl?.split("/");
      let getToken = splitToken[splitToken?.length - 1];
      let webLinkPayload = {
        data: {
          locallyIndex: true,
          title: "Kjuup",
          ratingAverage: 4.2,
          registraTionToken: getToken,
        },
      };
      window.branch.link(webLinkPayload, (err, link) => {
        setDeepLink(link);
      });
    }
  };

  useEffect(() => {
    if (!props.isInternal) {
      getProjectDetails();
    }
  }, [props.project_id, props.isInternal]);

  useEffect(() => {
    if (project && !props.isInternal) {
      getInviteLink();
    }
  }, [project, props.isInternal]);

  const handleCopyLink = async () => {
    const receiverMessage = deeplink
      ? isGerm
        ? `${DE.project_sender_message}\n\n${deeplink}`.replaceAll("project name", project?.name || "")
        : `${EN.project_sender_message}\n\n${deeplink}`.replaceAll("project name", project?.name || "")
      : "";
    navigator.clipboard.writeText(receiverMessage).then((r) => {
      $crud.notify({
        type: "success",
        message: strings.link_copied,
      });
    });
  };

  const addProjectUser = async () => {
    if (props?.addAsMember) {
      const id = props.project_id;
      if (selectedIds.length > 0) {
        let fnn = selectedIds.map(e => {
          return { user: e }
        })
        fnn = fnn.filter(e => e.user != user.id)
        console.log('---------->selecteed id', fnn)
        setLoader(true)
        const { data } = await callAPI(props.isInternal && props.cID ? `/building/${id}/add?companyId=${props.cID}` : `/building/${id}/add`, {}, "PUT", {
          id: id,
          users: fnn,
        });
        $crud.notify({
          type: data.status ? "success" : "error",
          message: data.message,
        });
        setPostUser([]);
        setSelectedIds([])
        setLoader(false)
        props.handleEditClose();
      } else {
        $crud.notify({
          type: "error",
          message: "Please select users to continue",
        });
      }
    } else {
      let compUses = []
      comps.map((e) => {
        if (e.employees) {
          let sll = e.employees.filter((x) => {
            return selectedIds.includes(x.id)
          })
          let slll = sll.map((e) => {
            return { ...e, nonmember: true, addStatus: true }
          })
          compUses = [...compUses, ...slll]
        }
      })
      let ids = []
      users.map((u) => {
        u.names.map(x => {
          let isIn = selectedIds.includes(x.id)
          if (isIn) {
            ids = [...ids, ...[{ ...x, nonmember: true, addStatus: true }]]
          }
        })
      });
      let MN = [...compUses, ...ids]
      let xx = MN.filter((value, index, self) => {
        return index === self.findIndex((t) => (
          t.id === value.id
        ))
      })
      props.setAddUserAction({ status: false, id: null, isInternal: props.isInternal, cID: props.cID, myMems: xx });
      props.setAddChatUserAction({ status: true, id: props.project_id, isInternal: props.isInternal, cID: props.cID, myMems: xx });
    }
  };

  const _getPosition = (cid, comp) => {
    if (Array.isArray(comp)) {
      let ind = comp.findIndex(e => e.id == cid)
      if (ind !== -1) {
        return capitalizeFirstLetter(comp[ind].position)
      }
    }
  }

  const _getCompanyNames = (companies) => {
    if (!Array.isArray(companies) || companies.length === 0) {
      return '';
    }
    return companies.map(c => c.name).filter(Boolean).join(', ');
  }

  const toggleCompany = (compId, index, hasEmps) => {
    setOpenCompanies((prev) => {
      const next = new Set(prev);
      if (next.has(compId)) next.delete(compId);
      else next.add(compId);
      return next;
    });
    if (!hasEmps) _getEmps(compId, index);
  }

  const _getEmps = async (compId, index) => {
    let tmp = [...comps]
    tmp[index].isGettingEmps = true
    setComps([...tmp])
    let xxt = [...users]
    const { data } = await callAPI(`/company/${compId}/admin`, {}, 'GET')
    if (data.status) {
      let xcv = []
      for (let obj of data.coworker) {
        let fx = props.Mems.findIndex(e => e.id == obj.id)
        if (fx == -1) {
          tmp.map(e => {
            if (e.employees) {
              let allIds = e.employees.map(e => {
                return e.id
              })
              let mainArray = [...selectedIds]
              mainArray = mainArray.filter(item => allIds?.includes(item));
              mainArray = [...new Set([...mainArray])]
              let filteredrmps = e.employees.map(j => {
                if (obj.id == j.id) {
                  obj.isEmpSelected = j.isEmpSelected
                }
                return { ...j }
              })
              return { ...e, employees: filteredrmps, inviteAllSelcted: (mainArray.length == e.employees?.length) ? true : false }
            }
            else {
              return { ...e }
            }
          })
          xcv.push(obj)
        }
        else {
          // obj = { ...obj, isInvited: true }
          // xcv.push(obj)
        }
      }
      let ll = xcv.filter(e => e.isEmpSelected)
      let llx = xcv.filter(e => e.isInvited)
      if (ll.length == xcv.length) {
        tmp[index].inviteAllSelcted = true
      }
      if (llx.length == xcv.length) {
        tmp[index].hideInviteAll = true
      }
      tmp[index].employees = (xcv && xcv.length > 0) ? xcv : null
      tmp[index].isGettingEmps = false
      setComps([...tmp])
      tmp.map(e => {
        if (e.employees) {
          e.employees.map(j => {
            xxt.map((d, i) => {
              if (d.names) {
                d.names.map((g, k) => {
                  if (j.id == g.id) {
                    xxt[i].names.splice(k, 1)
                  }
                })
              }
            })
            return { ...j }
          })
          return { ...e }
        }
        else {
          return { ...e }
        }
      })
      setUsers([...xxt])
    }
    else {
      tmp[index].employees = null
      tmp[index].isGettingEmps = false
      setComps([...tmp])
    }
    console.log('-------------->emps', data)
  }

  const _getDisabled = () => {
    let x = []
    for (let obj of comps) {
      if (obj.employees) {
        let b = obj.employees?.filter(e => e.isEmpSelected)
        if (b) {
          let t = b.map(e => {
            const data = {
              user: e.id,
            };
            return data;
          })
          x = [...x, ...t]
        }
      }
    }
    if (x.length > 0) {
      return true
    }
    else {
      let x = []
      users.map((e, i) => {
        e.names.map((j, k) => {
          if (j.addStatus) {
            x.push(j)
          }
        })
      })
      return x.length > 0 ? true : false
    }
  }

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    // Near the bottom (not pixel-exact: zoomed browsers report fractional scrollTop).
    if (scrollHeight - scrollTop - clientHeight < 80) loadMore();
  };

  return (
    <React.Fragment>
      {!inviteLink && (
        <div className="company_section company_list right_company border-radius-0 add-project-user">
          <div className="company_header add-project-user__header">
            <div class="heading_icon m-0">
              <a
                onClick={(e) => props.handleEditClose(props.isInternal, props.cID)}
                className={`main_heading pointer add-project-user__cancel${props.isInternal ? " add-project-user__cancel--internal" : ""}`}
              >
                <span className={`material-symbols-outlined material-arrow-left ${props.isInternal ? 'internal-arrow' : ''}`}>
                  keyboard_arrow_left
                </span>
                <span className="add-project-user__link-label">{strings.cancel}</span>
              </a>
              <h3 className="page-title">
                {strings.add_user}
              </h3>
              {(() => {
                const isActive = selectedIds.length > 0 && !loader;
                const isInternalProject = !!props.isInternal;
                
                const buttonClass = isActive 
                  ? (isInternalProject ? "continue-btn-active-internal" : "continue-btn-active-external")
                  : "continue-btn-inactive";
                
                return (
                  <a
                    onClick={() => {
                      if (isActive) {
                        addProjectUser()
                      }
                    }}
                    className={`main_heading ${buttonClass} add-project-user__continue${isActive ? "" : " add-project-user__continue--inactive"}`}
                  >
                    <span className="add-project-user__link-label">
                      {strings.continue}
                    </span>
                    <img
                      className="arrow-icon-inline"
                      width={16}
                      height={16}
                      src={process.env.PUBLIC_URL + "/assets/img/arrow-right-modern-gray.svg"}
                      alt=""
                    />
                  </a>
                );
              })()}
            </div>
          </div>
          <div className="company_list_ver add-project-user__list">
            <div className="my-scroll m-0 add_scrool add-project-user__scroll">
              <CustomScrollbars
                autoHide
                autoHideTimeout={500}
                autoHideDuration={200}
                onScroll={handleScroll}
                renderThumbHorizontal={() => <div style={{ display: 'none', height: 0 }} />}
                renderTrackHorizontal={() => <div style={{ display: 'none', height:0 }} />}
                renderView={(props) => (
                  <div {...props} style={{ ...props.style, overflowX: 'hidden' }} />
                )}
              >
                {/* Invite link section - commented out for potential re-implementation
                {!props.isInternal ? (
                  <div style={{ display: "flex", flexDirection: "column", padding: "0 20px", cursor: "pointer" }}>
                    <div style={{
                      backgroundColor: "#fff",
                      marginBottom: 20,
                      marginTop: 10,
                      alignSelf: "flex-start",
                      padding: "16px 20px",
                      borderRadius: 12,
                      width: '100%',
                      maxWidth: 'fit-content'
                    }}>
                      <p style={{
                        width: "100%",
                        maxWidth: "600px",
                        fontSize: "var(--kjuup-type-body)",
                        color: "#737373",
                        marginBottom: 16,
                        lineHeight: '1.5',
                        margin: '0 0 16px 0'
                      }}>
                        {project?.name ? (
                          `${strings.project_sender_message
                          }`.replaceAll("project name", project?.name || "")
                        ) : (
                          <span>Loading...</span>
                        )}
                      </p>
                      <div onClick={deeplink ? handleCopyLink : undefined} className="pointer" style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        cursor: deeplink ? 'pointer' : 'default'
                      }}>
                        <span className="material-symbols-outlined copy-link-icon" style={{ color: 'var(--kjuup-accent)' }}>content_copy</span>
                        <span style={{
                          fontSize: "14px",
                          color: "var(--kjuup-accent)",
                          fontWeight: 500
                        }}>
                          {strings.copy_link}
                        </span>
                      </div>
                      <div style={{
                        marginTop: 12,
                        fontSize: "12px",
                        color: "#737373",
                        fontStyle: "italic"
                      }}>
                        {(() => {
                          const text = strings.link_expire;
                          return text
                            .replace('72 hours', '10 days')
                            .replace('72 ore', '10 giorni')
                            .replace('72 Stunden', '10 Tage')
                            .replace('72 heures', '10 jours')
                            .replace('72 horas', '10 días')
                            .replace('72 uur', '10 dagen')
                            .replace('72 timer', '10 dager')
                            .replace('72 timmar', '10 dagar')
                            .replace('72 tuntia', '10 päivää')
                            .replace('72 godziny', '10 dni')
                            .replace('72 saat', '10 gün')
                            .replace('72 ώρες', '10 ημέρες')
                            .replace('72 hodin', '10 dní')
                            .replace('72 óra', '10 nap')
                            .replace('72 de ore', '10 zile')
                            .replace('72 sata', '10 dana')
                            .replace('72 ur', '10 dni')
                            .replace('72小时', '10天')
                            .replace('72 घंटे', '10 दिन')
                            .replace('72 ساعة', '10 أيام')
                            .replace('72時間', '10日')
                            .replace('72시간', '10일')
                            .replace('72 giờ', '10 ngày')
                            .replace('72 jam', '10 hari')
                            .replace('72 மணி', '10 நாட்கள்')
                            .replace('72 గంటలు', '10 రోజులు')
                            .replace('72 часа', '10 дней')
                            .replace('72 часа', '10 дни');
                        })()}
                      </div>
                    </div>
                  </div>
                ) : null}
                */}
                <div className="invite p-2">
                  <div className="admin_right">
                    <div className="search_div add-project-user__search">
                      <div className="search">
                        <Form.Group controlId="exampleForm.ControlInput1">
                          <Form.Control
                            autoComplete="off"
                            type="search"
                            onChange={handleSearchChange}
                            placeholder={strings.search}
                            value={search}
                          />
                        </Form.Group>
                      </div>
                    </div>
                    {
                      props.isInternal ?
                        (users && users.length > 0) ?
                          <div
                            className="admin-contact"
                            onClick={() => {
                              let x = !isAllMember
                              setIsAllMember(x)
                              if (x) {
                                let tmpids = []
                                users.map(e => {
                                  e.names.map(x => {
                                    tmpids.push(x.id)
                                  })
                                })
                                setSelectedIds([...tmpids])
                              }
                              else {
                                setSelectedIds([])
                              }
                            }}
                          >
                            <div className="row m-0">
                              <div className="col-md-10 p-0">
                                <div className="admin-control">
                                  <span className="add-project-user__invite-all-label">
                                    {strings.invite_all}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="custom_checkbox">
                                  <label className={props.isInternal ? "role-label-internal" : "role-label"}>
                                    <input
                                      disabled
                                      checked={isAllMember}
                                      type="checkbox"
                                    />
                                    <span className={props.isInternal ? "checkmark-label-internal" : "checkmark-label"} />
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          :
                          <div className="add-project-user__empty">
                            <span className="add-project-user__empty-text">{!isGerm ? 'All available employees have already joined the project. Please invite missing employees to the company.' : "Alle Mitarbeiter/innen sind dem Projekt bereits beigetreten. Fehlende Mitarbeiter/innen bitte zunächst zur Firma einladen."}</span>
                          </div>
                        :
                        <></>
                    }
                    {
                      !props.isInternal ?
                        search ?
                          <div className="admin-content">
                            {allToSearch &&
                              allToSearch.map((u, i) => (
                                (u.id != user.id && props.Mems.findIndex(e => e.id == u.id) == -1) ?
                                  <div>
                                    <div
                                      key={i}
                                      className="admin-contact"
                                      onClick={() => {
                                        let ids = [...selectedIds]
                                        let ind = ids.findIndex(x => x == u.id)
                                        if (ind !== -1) {
                                          ids.splice(ind, 1)
                                        }
                                        else {
                                          ids.push(u.id)
                                        }
                                        setSelectedIds(ids)
                                      }}
                                    >
                                      <div className="row m-0">
                                        <div className="col-md-10 p-0">
                                          <div className="admin-control">
                                            {u.avatar ?
                                              <ImageWithPlaceholder
                                                width={30}
                                                height={30}
                                                className="news_profile add-project-user__avatar add-project-user__avatar--photo"
                                                src={BASE_URL + u.avatar}
                                                alt="G"
                                                fallbackSrc={(process.env.PUBLIC_URL + "/assets/img/head.svg")}
                                                key={u.id}
                                                isKjuup={props.isInternal || u.isKjuup || u.companies?.some(c => c.isKjuup)}
                                              />
                                              :
                                              <img
                                                width={30}
                                                height={30}
                                                className={`news_profile add-project-user__avatar${(props.isInternal || u.isKjuup || u.companies?.some(c => c.isKjuup)) ? " add-project-user__avatar--kjuup" : ""}`}
                                                src={(process.env.PUBLIC_URL + "/assets/img/head.svg")}
                                                alt="Generic placeholder"
                                              />
                                            }
                                            <h4 className={u.companies && u.companies.length > 0 ? 'has-company-names' : ''}>
                                              {u.fullName}
                                              {u.companies && u.companies.length > 0 && (
                                                <span
                                                  className="company-names"
                                                  title={_getCompanyNames(u.companies)}
                                                >
                                                  {_getCompanyNames(u.companies)}
                                                </span>
                                              )}
                                            </h4>
                                          </div>
                                        </div>
                                        <div className="col-md-2" pr-0>
                                          <div className="custom_checkbox">
                                            <label className={props.isInternal ? "role-label-internal" : "role-label"}>
                                              <input
                                                checked={selectedIds.findIndex((e) => e == u.id) !== -1 ? true : false}
                                                disabled
                                                type="checkbox"
                                                value={u.id}
                                              />
                                              <span className={props.isInternal ? "checkmark-label-internal" : "checkmark-label"}></span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  :
                                  <></>
                              ))}
                          </div>
                          :
                          comps && comps?.length > 0 ?
                            <div className="company-accordion-section add-project-user__accordion">
                              {comps.map((e, i) => {
                                const isOpen = openCompanies.has(e.id);
                                const filteredEmployees = (e.employees || []).filter(u => u.id != user.id && props.Mems.findIndex(m => m.id == u.id) == -1);
                                return (
                                  <div key={e.id} className="add-project-user__company">
                                    <div
                                      onClick={() => toggleCompany(e.id, i, !!e.employees)}
                                      className="add-project-user__company-head"
                                    >
                                      <span className="add-project-user__company-name">
                                        {e.name} {e.employees ? `(${filteredEmployees.length})` : ''}
                                      </span>
                                      <span className="material-symbols-outlined add-project-user__company-caret">
                                        {isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                                      </span>
                                    </div>
                                    {isOpen && (
                                      <div className="add-project-user__company-list">
                                        {e.isGettingEmps ? (
                                          <div className="add-project-user__company-loading">
                                            <Oval height={30} width={30} color={KJUUP_COLORS.base_color} wrapperStyle={{}} wrapperClass="" visible={true} ariaLabel='oval-loading' secondaryColor={'#f7f7f7'} strokeWidth={5} strokeWidthSecondary={5} />
                                          </div>
                                        ) : e.employees && e.employees.length > 0 ? (
                                          <>
                                            {filteredEmployees.length > 0 ? (
                                              <div
                                                onClick={() => {
                                                  let tmp = [...comps];
                                                  tmp[i].inviteAllSelcted = !tmp[i].inviteAllSelcted;
                                                  if (tmp[i].inviteAllSelcted) {
                                                    let allIds = filteredEmployees.map(emp => emp.id);
                                                    let txx = [...selectedIds];
                                                    txx = [...new Set([...txx, ...allIds])];
                                                    setSelectedIds([...txx]);
                                                  } else {
                                                    let mainArray = [...selectedIds];
                                                    let allIds = filteredEmployees.map(emp => emp.id);
                                                    mainArray = mainArray.filter(item => !allIds.includes(item));
                                                    mainArray = [...new Set([...mainArray])];
                                                    setSelectedIds([...mainArray]);
                                                  }
                                                  setComps([...tmp]);
                                                }}
                                                className="mx-1 add-project-user__select-all"
                                              >
                                                <div className="row m-0 mx-1 align-items-center">
                                                  <div className="col-md-10 p-0">
                                                    <span className="add-project-user__select-all-label">
                                                      {strings.invite_all}
                                                    </span>
                                                  </div>
                                                  <div className="col-md-2">
                                                    <div className="custom_checkbox">
                                                      <label className={`${props.isInternal ? "role-label-internal" : "role-label"} add-project-user__check-label`}>
                                                        <input disabled checked={e.inviteAllSelcted} type="checkbox" onClick={() => {}} />
                                                        <span className={props.isInternal ? "checkmark-label-internal" : "checkmark-label"} />
                                                      </label>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : (
                                              <div className="add-project-user__company-note">
                                                <span className="add-project-user__company-note-text">
                                                  {!isGerm ? 'All employees have already joined the project.' : "Alle Mitarbeiter/innen sind dem Projekt bereits beigetreten."}
                                                </span>
                                              </div>
                                            )}
                                            <div className="admin-content add-project-user__company-users">
                                              {filteredEmployees.map((u, index) => (
                                                <div key={`company-${e.id}-${u.id}`} className="admin-contact" onClick={() => {
                                                  let ids = [...selectedIds];
                                                  let ind = ids.findIndex(x => x == u.id);
                                                  if (ind !== -1) ids.splice(ind, 1);
                                                  else ids.push(u.id);
                                                  setSelectedIds(ids);
                                                  let tmp = [...comps];
                                                  for (let obj of tmp) {
                                                    let mainArray = [...ids];
                                                    let allIds = obj.employees?.map(emp => emp.id) || [];
                                                    mainArray = mainArray.filter(item => allIds.includes(item));
                                                    mainArray = [...new Set([...mainArray])];
                                                    const objFiltered = (obj.employees || []).filter(emp => emp.id != user.id && props.Mems.findIndex(m => m.id == emp.id) == -1);
                                                    obj.inviteAllSelcted = mainArray.length === objFiltered.length && objFiltered.length > 0;
                                                  }
                                                  setComps([...tmp]);
                                                }}>
                                                  <div className="row m-0 mx-1">
                                                    <div className="col-md-10 p-0">
                                                      <div className="admin-control add-project-user__control">
                                                        {u.avatar ?
                                                          <ImageWithPlaceholder
                                                            width={30}
                                                            height={30}
                                                            className="news_profile add-project-user__avatar add-project-user__avatar--photo add-project-user__avatar--offset"
                                                            src={BASE_URL + u.avatar}
                                                            alt="G"
                                                            fallbackSrc={(process.env.PUBLIC_URL + "/assets/img/head.svg")}
                                                            isKjuup={props.isInternal || u.isKjuup || u.companies?.some(c => c.isKjuup)}
                                                          />
                                                          :
                                                          <img
                                                            width={30}
                                                            height={30}
                                                            className={`news_profile add-project-user__avatar add-project-user__avatar--offset${(props.isInternal || u.isKjuup || u.companies?.some(c => c.isKjuup)) ? " add-project-user__avatar--kjuup" : ""}`}
                                                            src={(process.env.PUBLIC_URL + "/assets/img/head.svg")}
                                                            alt="Generic placeholder"
                                                          />
                                                        }
                                                        <h4 className={u.companies && u.companies.length > 0 ? 'has-company-names' : ''}>
                                                          {u.fullName}
                                                          {u.companies && u.companies.length > 0 && (
                                                            <span
                                                              className="company-names"
                                                              title={_getCompanyNames(u.companies)}
                                                            >
                                                              {_getCompanyNames(u.companies)}
                                                            </span>
                                                          )}
                                                        </h4>
                                                      </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                      <div className="custom_checkbox">
                                                        <label className={props.isInternal ? "role-label-internal" : "role-label"}>
                                                          <input
                                                            checked={selectedIds.includes(u.id)}
                                                            disabled
                                                            type="checkbox"
                                                            value={u.id}
                                                          />
                                                          <span className={props.isInternal ? "checkmark-label-internal" : "checkmark-label"}></span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ))}
                                            </div>
                                          </>
                                        ) : !e.isGettingEmps ? (
                                          <div className="add-project-user__company-note">
                                            <span className="add-project-user__company-note-text">
                                              {!isGerm ? 'All employees have already joined the project.' : "Alle Mitarbeiter/innen sind dem Projekt bereits beigetreten."}
                                            </span>
                                          </div>
                                        ) : null}
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                            :
                            <></>
                        :
                        <></>
                    }
                    {
                      !props.isInternal && comps && comps?.length > 0 && !search ?
                        <div className="add-project-user__divider" />
                        :
                        <></>
                    }
                    {!search ?
                      <div className="admin-content">
                        {users &&
                          users.flatMap((user) =>
                            user.names?.filter((u) => u.id != user.id && props.Mems.findIndex(e => e.id == u.id) == -1)
                              .map((u, i) => (
                                <div key={`${user.name}-${i}`} className="admin-contact" onClick={() => {
                                  let ids = [...selectedIds]
                                  let ind = ids.findIndex(x => x == u.id)
                                  if (ind !== -1) {
                                    ids.splice(ind, 1)
                                  }
                                  else {
                                    ids.push(u.id)
                                  }
                                  setSelectedIds(ids)
                                }}>
                                  <div className="row m-0">
                                    <div className="col-md-10 p-0">
                                      <div className="admin-control">
                                        {u.avatar ?
                                          <ImageWithPlaceholder
                                            width={30}
                                            height={30}
                                            className="news_profile add-project-user__avatar add-project-user__avatar--photo"
                                            src={BASE_URL + u.avatar}
                                            alt="G"
                                            fallbackSrc={(process.env.PUBLIC_URL + "/assets/img/head.svg")}
                                            isKjuup={props.isInternal || u.isKjuup || u.companies?.some(c => c.isKjuup)}
                                          />
                                          :
                                          <img
                                            width={30}
                                            height={30}
                                            className={`news_profile add-project-user__avatar${(props.isInternal || u.isKjuup || u.companies?.some(c => c.isKjuup)) ? " add-project-user__avatar--kjuup" : ""}`}
                                            src={(process.env.PUBLIC_URL + "/assets/img/head.svg")}
                                            alt="Generic placeholder"
                                          />
                                        }
                                        <h4 className={u.companies && u.companies.length > 0 ? 'has-company-names' : ''}>
                                          {u.fullName}
                                          {u.companies && u.companies.length > 0 && (
                                            <span
                                              className="company-names"
                                              title={_getCompanyNames(u.companies)}
                                            >
                                              {_getCompanyNames(u.companies)}
                                            </span>
                                          )}
                                        </h4>
                                      </div>
                                    </div>
                                    <div className="col-md-2" pr-0>
                                      <div className="custom_checkbox">
                                        <label className={props.isInternal ? "role-label-internal" : "role-label"}>
                                          <input
                                            checked={selectedIds.findIndex((e) => e == u.id) !== -1 ? true : false}
                                            disabled
                                            type="checkbox"
                                            value={u.id}
                                          />
                                          <span className={props.isInternal ? "checkmark-label-internal" : "checkmark-label"}></span>
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                          )}
                      </div>
                      :
                      props.isInternal ?
                        <div className="admin-content">
                          {allToSearch &&
                            allToSearch.map((u, i) => (
                              (u.id != user.id && props.Mems.findIndex(e => e.id == u.id) == -1) ?
                                <div>
                                  <div key={i} className="admin-contact" onClick={() => {
                                    let ids = [...selectedIds]
                                    let ind = ids.findIndex(x => x == u.id)
                                    if (ind !== -1) {
                                      ids.splice(ind, 1)
                                    }
                                    else {
                                      ids.push(u.id)
                                    }
                                    setSelectedIds(ids)
                                  }} >
                                    <div className="row m-0">
                                      <div className="col-md-10 p-0">
                                        <div className="admin-control">
                                          {u.avatar ?
                                            <ImageWithPlaceholder
                                              width={30}
                                              height={30}
                                              className="news_profile add-project-user__avatar add-project-user__avatar--photo"
                                              src={BASE_URL + u.avatar}
                                              alt="G"
                                              fallbackSrc={(process.env.PUBLIC_URL + "/assets/img/head.svg")}
                                              isKjuup={props.isInternal || u.isKjuup || u.companies?.some(c => c.isKjuup)}
                                            />
                                            :
                                            <img
                                              width={30}
                                              height={30}
                                              className={`news_profile add-project-user__avatar${(props.isInternal || u.isKjuup || u.companies?.some(c => c.isKjuup)) ? " add-project-user__avatar--kjuup" : ""}`}
                                              src={(process.env.PUBLIC_URL + "/assets/img/head.svg")}
                                              alt="Generic placeholder"
                                            />
                                          }
                                          <h4 className={u.companies && u.companies.length > 0 ? 'has-company-names' : ''}>
                                            {u.fullName}
                                            {u.companies && u.companies.length > 0 && (
                                              <span
                                                className="company-names"
                                                title={_getCompanyNames(u.companies)}
                                              >
                                                {_getCompanyNames(u.companies)}
                                              </span>
                                            )}
                                          </h4>
                                        </div>
                                      </div>
                                      <div className="col-md-2" pr-0>
                                        <div className="custom_checkbox">
                                          <label className={props.isInternal ? "role-label-internal" : "role-label"}>
                                            <input
                                              checked={selectedIds.findIndex((e) => e == u.id) !== -1 ? true : false}
                                              disabled
                                              type="checkbox"
                                              value={u.id}
                                            />
                                            <span className={props.isInternal ? "checkmark-label-internal" : "checkmark-label"}></span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                :
                                <></>
                            ))}
                        </div>
                        :
                        <></>
                    }
                    {hasMore && (
                      <div className="add-project-user__loading-more">
                        <Oval
                          height={30}
                          width={30}
                          color={KJUUP_COLORS.base_color}
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={true}
                          ariaLabel='oval-loading'
                          secondaryColor={'#f7f7f7'}
                          strokeWidth={5}
                          strokeWidthSecondary={5}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </CustomScrollbars>
            </div>
          </div>
        </div>
      )}
      {inviteLink && (
        <InviteProjectUser
          project_id={props.project_id}
          handleClose={(e) => setInviteLink(false)}
        />
      )}
    </React.Fragment>
  );
}

export default AddProjectUser;
